import { inject, InjectionToken } from '@angular/core';
import { APP_CONFIG, ImproverAngularEnvironment } from '@improver/app-config';

export interface EmploymentAccessApiEndpoints {
  MANAGED_EMPLOYMENT_ACCESS: () => string;
  MY_EMPLOYMENT_ACCESS: () => string;
}

export const EMPLOYMENT_ACCESS_ENDPOINTS = new InjectionToken<EmploymentAccessApiEndpoints>('endpoints.employment-access', {
  factory: () => {
    const environment: ImproverAngularEnvironment = inject(APP_CONFIG);
    const { authorization }: { authorization: string } = environment.services;
    const hrrBacBase = `${authorization}/hrrbac`;

    return {
      MANAGED_EMPLOYMENT_ACCESS: () => `${hrrBacBase}/managed-employments-access-map`,
      MY_EMPLOYMENT_ACCESS: () => `${hrrBacBase}/my-employments-access`,
    };
  },
});
